import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { IconContext } from "react-icons/lib";
import { animateScroll as scroll } from "react-scroll";
import logo from "../../images/logo.svg";
import LanguageButtons from "../LanguageButtons";
import {
  Nav,
  NavbarContainer,
  NavLogo,
  Img,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLinks,
  HamburguerIcon,
  H1,
} from "./NavbarProjectElements";

const NavbarProject = ({ toggle }) => {
  const [scrollNav, setScrollNav] = useState(false);
  const { t } = useTranslation();

  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeNav);
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <Nav scrollNav={scrollNav}>
          <NavbarContainer>
            <H1>
              <NavLogo to="/" onClick={toggleHome}>
                <Img src={logo} alt="Logo Bonus Consultoria" />
              </NavLogo>
            </H1>
            <MobileIcon onClick={toggle}>
              <HamburguerIcon />
            </MobileIcon>
            <NavMenu>
              <NavItem>
                <NavLinks
                  to={{pathname:"/",state:{div:'consulting'}}}
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  {t("navbar_consulting")}
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to={{pathname:"/",state:{div:'contact'}}}
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  {t("navbar_contact")}
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to={{pathname:"/",state:{div:'projects'}}}
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  {t("navbar_projects")}
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to={{pathname:"/",state:{div:'testimony'}}}
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  {t("navbar_testimonial")}
                </NavLinks>
              </NavItem>
            </NavMenu>
            <LanguageButtons />
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
};

export default NavbarProject;
